import axios, { Method } from 'axios';
import QueryString from 'qs';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import logo from '../assets/assessoria/logoSulamericaWhite.svg';
import atentionIcon from '../assets/svgs/atention-icon.svg';
import checkIcon from '../assets/svgs/check-icon.svg';
import { CustomIcon } from '../components/widgets/CustomIcon';
import { useAuthContext } from '../contexts/AuthContext';
import { api } from '../services/api';
import { apiSensedia } from '../services/api-sensedia';

// const apiNotificacoes = apiSensedia;

// if (process.env.NODE_ENV != 'development') {
//   apiNotificacoes = apiSensedia;
// }

export const EmailConfirmation = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const confirmToken = urlParams.get('confirmToken');

  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [emailConfirmation, setEmailConfirmation] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const user = localStorage.getItem('pdn:user');
  const tokenCreatedAt = Number(localStorage.getItem('tokenCreatedAt'));
  const tokenPortal = localStorage.getItem('tokenPortal');

  const handleEmailConfirmation = async () => {
    const emailHeader = { 'email-verification-token': confirmToken };
    setIsLoading(true);

    try {
      const data = QueryString.stringify({
        grant_type: 'client_credentials'
      });

      const config = {
        method: 'POST' as Method,
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_SENSEDIA_OAUTH_API}/access-token`,
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_SENSEDIA_CLIENT_ID}`,
          'tipo-usuario': 'UG',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data
      };

      const accessTokenResponse = await axios.request(config);

      // console.log('o access token', accessTokenResponse.data.access_token);

      const response = await axios.post(
        `${process.env.REACT_APP_API_SENSEDIA_URL}/notificacoes/contatos/email/verificar`,
        {},
        {
          headers: {
            ...emailHeader,
            Authorization: `Bearer ${accessTokenResponse.data.access_token}`
          }
        }
      );

      setEmail(response.data.email);
      setEmailConfirmation(response.data.status === 'success');
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleRedirectButton = () => {
    const parsedUser = JSON.parse(user);
    const expiresIn = 3600;
    const currentTimestamp = Date.now();
    const difference = (currentTimestamp - tokenCreatedAt) / 1000;

    const isUserLoggedIn = parsedUser?.user;
    const hasToken = tokenPortal;
    const isTokenValid = difference < expiresIn;

    if (isUserLoggedIn && hasToken && isTokenValid) {
      navigate(
        emailConfirmation ? '/corretor' : '/corretor/notificacoes/configuracoes'
      );
    } else {
      navigate('/login');
    }
  };

  useEffect(() => {
    handleEmailConfirmation();
  }, []);

  return !isLoading ? (
    <div className="tw-flex tw-flex-col tw-items-center">
      <div className="tw-bg-[#001E64] tw-flex tw-justify-between tw-py-[30px] tw-px-[25px] tw-w-screen">
        <img src={logo} className="tw-w-[123px] tw-h-[32px]" alt="Logo" />
      </div>
      <div className="tw-flex tw-flex-col tw-items-center tw-mt-14">
        <CustomIcon
          src={emailConfirmation ? checkIcon : atentionIcon}
          width={48}
          height={48}
        />
        <h2
          style={{ color: emailConfirmation ? '#006217' : '#AA2C23' }}
          className="tw-font-bold tw-text-[1.5rem] tw-mt-5"
        >
          {emailConfirmation
            ? 'E-mail confirmado com sucesso!'
            : 'Link de validação de e-mail expirado'}
        </h2>

        <p className="tw-text-[#323232] tw-text-[1.25rem] tw-text-center tw-mt-2 tw-max-w-[40rem]">
          {emailConfirmation
            ? `Agora, você começará a receber notificações no endereço de e-mail registrado(${email})`
            : ' Por favor, volte para a página de envio de e-mail e tente novamente.'}
        </p>

        <button
          className="tw-rounded-full tw-bg-[#FF5000] tw-py-3 tw-px-12 tw-max-h-12 tw-text-white tw-font-bold tw-mt-8"
          onClick={handleRedirectButton}
        >
          Acessar plataforma de negócios
        </button>
      </div>
    </div>
  ) : (
    <div className="tw-flex tw-flex-col tw-items-center">
      <div className="tw-bg-[#001E64] tw-flex tw-justify-between tw-py-[30px] tw-px-[25px] tw-w-screen">
        <img src={logo} className="tw-w-[123px] tw-h-[32px]" alt="Logo" />
      </div>
      <div className="tw-pt-[7.75rem] tw-pb-[12rem] tw-flex tw-flex-col tw-gap-7 tw-justify-center tw-items-center">
        <div
          style={{ borderTopColor: 'transparent' }}
          className="tw-w-20 tw-h-20 tw-border-4 tw-border-[#001E64] tw-border-solid tw-rounded-full tw-animate-spin"
        ></div>
      </div>
    </div>
  );
};
